"use client";

import { motion } from "motion/react";
import styles from "./LaitLoader.module.css";

export const LaitLoader = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ delay: 2, ease: "easeInOut", duration: 0.5 }}
      className={styles.loader}
    >
      <span>
        <svg
          role="img"
          aria-hidden={true}
          width="99"
          height="128"
          viewBox="0 0 99 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_975_1712)">
            <path
              d="M57.0684 33.4932H41.2005L40.3449 35.4378L0.0529785 128H17.6321L49.1344 55.6615L80.7146 128H98.2937L57.924 35.4378L57.0684 33.4932Z"
              fill="#769FCD"
            />
          </g>
          <defs>
            <clipPath id="clip0_975_1712">
              <rect
                width="98"
                height="128"
                fill="white"
                transform="translate(0.552979)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
      <span className={styles.secondSpan}>
        <svg
          role="img"
          aria-hidden={true}
          width="99"
          height="128"
          viewBox="0 0 99 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_975_1714)">
            <path
              d="M58.0827 35.3967L57.2458 33.4209L41.3634 33.4664L40.5255 35.3922L16.0933 91.3512L0.17334 127.941L17.7306 127.945L27.4749 105.549L71.0563 105.595L80.82 127.996L98.3772 128.001L58.0827 35.3967ZM33.7218 91.3868L49.3004 55.5817L64.8633 91.3639L33.7218 91.3868Z"
              fill="#769FCD"
            />
          </g>
          <defs>
            <clipPath id="clip0_975_1714">
              <rect
                width="98"
                height="128"
                fill="white"
                transform="translate(0.552979)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
      <span>
        <svg
          role="img"
          aria-hidden={true}
          xmlns="http://www.w3.org/2000/svg"
          width="81"
          height="128"
          viewBox="0 0 81 128"
          fill="none"
        >
          <g clipPath="url(#clip0_975_1716)">
            <path
              d="M64.416 33.4932L54.8486 47.7276L25.2131 91.442L15.879 105.21V105.599H15.6457L15.879 105.21V33.4932H0.94458V128H17.1236L32.2914 105.599L41.8587 91.442L65.7383 56.1282V128H80.6728V33.4932H64.416Z"
              fill="#769FCD"
            />
            <path
              d="M45.5997 5.81126e-05L32.5227 19.3262L42.5079 26.0826L55.5848 6.7565L45.5997 5.81126e-05Z"
              fill="#769FCD"
            />
          </g>
          <defs>
            <clipPath id="clip0_975_1716">
              <rect
                width="79.7282"
                height="128"
                fill="white"
                transform="translate(0.94458)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
      <span>
        <svg
          role="img"
          aria-hidden={true}
          width="82"
          height="128"
          viewBox="0 0 82 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_975_1719)">
            <path
              d="M0.731445 33.5713V47.7279H33.5561V128.001H48.4906V47.7279H81.393V33.5713H0.731445Z"
              fill="#769FCD"
            />
          </g>
          <defs>
            <clipPath id="clip0_975_1719">
              <rect
                width="81"
                height="128"
                fill="white"
                transform="translate(0.28125)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
    </motion.div>
  );
};
